import * as React from "react";
import { OrderedMap } from "immutable";
import DateFilter from "views/components/widgets/overview-configuration/filters/DateFilter";
import StatusFilter from "search/events/filters/StatusFilter";
import Status from "search/events/Status";
import OwnerFilter from "security-app/components/SecurityEvents/Alerts/OwnerFilter";
import { OwnerCell } from "security-app/components/SecurityEvents/Alerts/ColumnRenderers";
const dateFilterComponents = {
  configuration: (_selectedValues, editValue, onChange) => /* @__PURE__ */ React.createElement(DateFilter, { values: editValue, onChange: (newValue) => onChange(newValue, false) }),
  renderValue: (values) => values.replace(",", " to "),
  valueForConfig: (values) => values.join(","),
  valueFromConfig: (value) => value ? value.split(",") : [],
  submitChangesOnClose: true
};
const filterComponents = [
  {
    attribute: "opened_at",
    ...dateFilterComponents
  },
  {
    attribute: "updated_at",
    ...dateFilterComponents
  },
  {
    attribute: "closed_at",
    ...dateFilterComponents
  },
  {
    configuration: (selectedValues, editValue, onChange) => /* @__PURE__ */ React.createElement(
      OwnerFilter,
      {
        attribute: { id: "owner", title: "Owner" },
        allActiveFilters: OrderedMap(
          selectedValues.length > 0 ? {
            owner: selectedValues.map((value) => ({ value, title: value }))
          } : {}
        ),
        filter: editValue ? { value: editValue, title: editValue } : void 0,
        filterValueRenderer: (value) => /* @__PURE__ */ React.createElement(OwnerCell, { owner: value }),
        onSubmit: ({ value }) => onChange(value)
      }
    ),
    attribute: "owner",
    renderValue: (value) => /* @__PURE__ */ React.createElement(OwnerCell, { owner: value }),
    allowMultipleValues: true
  },
  {
    configuration: (selectedValues, editValue, onChange) => /* @__PURE__ */ React.createElement(StatusFilter, { value: editValue, onSelect: onChange, selectedValues }),
    attribute: "status",
    renderValue: (value) => /* @__PURE__ */ React.createElement(Status, { statusId: value }),
    allowMultipleValues: true
  }
];
export default filterComponents;
